module.exports = __webpack_public_path__ + "static/media/fraudrisk.442a11be.svg";